// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fOde","col":"styles_col__26GLY"};